import axios, { InternalAxiosRequestConfig } from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";

import { getToken, storeToken, clearSession } from "./session";
import { resetUser } from "./posthog";
import { getSlug } from "../routes";

const basePath = {
  baseURL: process.env.REACT_APP_API,
};

const instance = axios.create();
const interceptedInstance = axios.create();
createAuthRefreshInterceptor(interceptedInstance, refreshTokenInterceptor);

interceptedInstance.interceptors.request.use(requestInterceptor);

function requestInterceptor(request: InternalAxiosRequestConfig) {
  // console.log(`[requestInterceptor]`)
  // get token
  const token = getToken();

  // if no token, stop, redirect to login
  if (!token) return goToLogin();

  request.headers.set("Authorization", `Bearer ${token.access_token}`);
  // continue with the request
  return request;
}

async function requestAccessToken(refresh_token: string) {
  const url = `${basePath.baseURL}/oauth/v2/token`;
  const params = {
    client_id: "1_qwgh3gijy6oc44kw04wco0swookgwgws0csww4cgw4oss80s4",
    client_secret: "44eugnuavykgosskw00c84wwoosc4oosk80000w88o48wkssso",
    grant_type: "refresh_token",
    refresh_token,
  };

  try {
    const token = await instance.post(url, params);
    return storeToken(token);
  } catch (error) {
    throw error;
  }
}

async function refreshTokenInterceptor(request: InternalAxiosRequestConfig) {
  // get token
  const currentToken = getToken();
  try {
    const token = await requestAccessToken(currentToken.refresh_token);
    request.headers.set("Authorization", `Bearer ${token.access_token}`);
    storeToken(token);
    return request;
  } catch (error) {
    console.error(`[requestInterceptor]`, error);
    clearSession();
    resetUser();

    goToLogin();
    return error;
  }
}

function goToLogin() {
  const slug = getSlug();

  window.location.href = `/${slug}/login?redirect=${window.location.pathname}`;
  return Promise.reject({ error: "No token!" });
}

export { interceptedInstance as api, instance as openApi, basePath };
